import { instance } from "../instance";
import { IAxiosError } from "../interfaces";
import { getError } from "../utils";
import { PATH } from "../../shared/constants";

export type CreateGamedayStoryInput = {
  story: string;
  name?: string;
  email?: string;
  permissionToContact?: boolean;
  teamId?: string;
  teamName?: string;
  gameId?: string;
  gameName?: string;
  eventDate?: number;
  userId?: string;
  photoId?: string;
  photoUrl?: string;
  section?: string;
  row?: string;
  seat?: string;
  suite?: string;
  specialSection?: string;
};

export const createGamedayStoryRequest = async (
  payload: CreateGamedayStoryInput,
): Promise<{ _id: string }> => {
  try {
    const response = await instance.post<{ _id: string }>(
      `${PATH.API}/${PATH.SUPPORT}/gameday-story`,
      payload,
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};
